export const GET_NOTIFICATION_COUNT = 'GET_NOTIFICATION_COUNT';

export interface INotificationTypes {
    GET_NOTIFICATION_COUNT: {
        notificationCount: number;
    };
}